import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StyledButton } from '../../../globalStyled';
import {
  StyledPopUp,
  StyledPopUpBlock,
  StyledCross,
  StyledPopUpContainer,
  StyledButtonContainer,
  StyledHeader,
  StyledParagraph,
  StyledLoader,
} from '../styled';
import { hidePopupWindow } from '../../../redux/actions/Popups';
import {
  teamCallFreeAgent,
  removeSelectedPlayer,
  transferDeleteUserWithOfferToBuy,
} from '../../../redux/actions/Transfers';

import { getSearchPlayerData } from '../../../redux/selector/Transfers';
import { getPopupsList } from '../../../redux/selector/Popups';

const SignFreeAgentPopup = ({ cash, popupName, id, deselectClicked }) => {
  const [defaultStep, showDefaultStep] = useState(true);

  const { isPopupLoading } = useSelector(getSearchPlayerData);

  const freeAgentPopupData = useSelector(getPopupsList);
  const { error } = freeAgentPopupData[popupName];
  const penaltiSize = 250000;
  const NSF = cash - penaltiSize < 0;
  useEffect(() => {
    showDefaultStep(true);
  }, []);
  const dispatch = useDispatch();
  const sendScout = () => {
    showDefaultStep(false);
    if (!NSF) {
      dispatch(teamCallFreeAgent(id));
    }
  };

  const hidePopup = () => {
    if (!isPopupLoading) {
      dispatch(hidePopupWindow(popupName));
    }
  };
  const closePopup = () => {
    // Confirm button after success opetaion remove table selection and removes row from table
    if (!defaultStep && !error && !NSF) {
      dispatch(removeSelectedPlayer(id));
      dispatch(transferDeleteUserWithOfferToBuy());
      deselectClicked();
      dispatch(hidePopupWindow(popupName));
    }
    // For errors only close popup
    if ((NSF && !error && !defaultStep) || error) {
      dispatch(hidePopupWindow(popupName));
    }
  };

  return (
    <StyledPopUp>
      <StyledPopUpBlock>
        <StyledCross onClick={() => hidePopup()} />
        <StyledPopUpContainer>
          {isPopupLoading ? (
            <StyledLoader
              type="Bars"
              color="var(--tol-header-accent)"
              height={100}
              width={100}
            />
          ) : (
            <>
              {defaultStep && (
                <>
                  <StyledHeader>Free agent fee</StyledHeader>
                  <StyledParagraph>
                    There is a $250,000 league fee for signing a free agent.
                  </StyledParagraph>
                  <StyledParagraph>Would you like to proceed?</StyledParagraph>
                </>
              )}
              {NSF && !error && !defaultStep && (
                <>
                  <StyledHeader> Not enough funds.</StyledHeader>
                  <StyledParagraph>
                    You do not have enough funds to pay for the league fee.
                  </StyledParagraph>
                </>
              )}
              {error && (
                <>
                  <StyledHeader> {error.header}</StyledHeader>
                  <StyledParagraph>{error.text}</StyledParagraph>
                </>
              )}
              {!defaultStep && !error && !NSF && (
                <>
                  <StyledHeader>Thank you.</StyledHeader>
                  <StyledParagraph>Free agent request was sent</StyledParagraph>
                </>
              )}
              <StyledButtonContainer>
                {defaultStep ? (
                  <>
                    <StyledButton onClick={() => hidePopup()}>
                      Cancel
                    </StyledButton>
                    <StyledButton primary onClick={sendScout}>
                      Proceed
                    </StyledButton>
                  </>
                ) : (
                  <StyledButton primary onClick={() => closePopup()}>
                    Got it!
                  </StyledButton>
                )}
              </StyledButtonContainer>
            </>
          )}
        </StyledPopUpContainer>
      </StyledPopUpBlock>
    </StyledPopUp>
  );
};

export default React.memo(SignFreeAgentPopup);
